import { Time } from "lightweight-charts";

import { ZERO } from "@/constants/math";
import type { ApiSwapCandlesResponse } from "@/types/api";
import type { BgType, Candle } from "@/types/common";

// todo split file semantically

/** @deprecated ? */
export const pathnameToBgType = (pathname?: string): BgType | undefined => {
  if (pathname == "/") {
    return "home";
  }
};

/** @deprecated ? */
export const pathnameToPrevRoute = (pathname?: string, previous?: string) => {
  if (
    pathname?.includes("watch-position") ||
    pathname?.includes("lend-info") ||
    pathname?.includes("earn")
  ) {
    return "/";
  }

  return previous;
};

/** @deprecated transformers */
export const toChartCandleSerie = (
  point: ApiSwapCandlesResponse["points"][number],
): Candle => ({
  time: point[0] as Time,
  open: ZERO.plus(point[1].open),
  high: ZERO.plus(point[1].high),
  low: ZERO.plus(point[1].low),
  close: ZERO.plus(point[1].close),
  volume: point[1].volumeBuy + point[1].volumeSell,
});

/** @deprecated math */
export const getPriceAggregates = (candles: Candle[] | undefined) => {
  if (!candles || candles.length === 0) return undefined;

  const diff = candles[candles.length - 1].close.minus(candles[0].open);
  const up = diff.gt(0);
  const percent = diff
    .div(candles[candles.length - 1].close)
    .times(100)
    .toNumber();
  return { diff, up, percent };
};

/** @deprecated */
export const getNetworkIcon = (networkId: number | undefined) => {
  const path = "/pools/images/network";
  switch (networkId) {
    case 1:
      return `${path}/ethereum.svg`;
    case 421613:
      return `${path}/arbitrum.svg`;
    case 80001:
      return `${path}/polygon.svg`;
    case 280:
      return `${path}/zksync.svg`;
    default:
      return "/pools/images/network/mainnet.svg";
  }
};
